import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgMailIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.333 16A2.667 2.667 0 0 1 8 13.333h48A2.667 2.667 0 0 1 58.666 16v32A2.667 2.667 0 0 1 56 50.667H8A2.667 2.667 0 0 1 5.333 48zm4.839 0 15.652 13.333h12.351L53.828 16zM56 17.653l-16.095 13.71a2.67 2.67 0 0 1-1.73.637H25.824a2.67 2.67 0 0 1-1.73-.637L8 17.653V48h48z"
    />
  </svg>
)
export default SvgMailIcon
